import React from 'react';
import MediaKitEditButton from './MediaKitEditButton';

interface MediaKitSectionHeaderProps {
    title: string;
    editLabel: string;
    onEdit: () => void;
    className?: string;
    titleClassName?: string;
    editable?: boolean;
}

export default function MediaKitSectionHeader({
    title,
    editLabel,
    onEdit,
    className = '',
    titleClassName = '',
    editable = true,
}: MediaKitSectionHeaderProps) {
    return (
        <div className={`media-kit-section-header${className ? ` ${className}` : ''}`}>
            <h3 className={titleClassName}>{title}</h3>
            {editable && <MediaKitEditButton label={editLabel} onClick={onEdit} />}
        </div>
    );
}
